import { dispatchIframeResizerEvent } from './dispatchIframeResizerEvent.js';

/**
 * Функция инициализирует обработчик событий iframe resizer. Он ловит сообщение от ресайзера и сохраняет полученные значение.
 * Нужен для того, чтобы при ресайзе мы могли получить актуальные значения окна.
 **/
const initIframeResizerEventHandler = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    window.iFrameResizer = {
        readyCallback: () => {
            dispatchIframeResizerEvent();
        },
    };
};

export { initIframeResizerEventHandler };
//# sourceMappingURL=initIframeResizerEventHandler.js.map
